<template>
  <div class="catalog">
    <div class="main__wrapepr">
      <div class="catalog__left">
        <div class="catalog__title">{{ pageData.catalog.title }}</div>
        <div class="catalog__desc">{{ pageData.catalog.description }}</div>
      </div>
      <div class="catalog__right">
        <swiper-container
          ref="swiperEl"
          init="false"
          v-if="pageData.categories"
          class="catalog__tabs__wrapper"
          space-between="16"
          slides-per-view="auto"
          centered-slides="true"
          centered-slides-bounds="true">
          <swiper-slide
            class="catalog__tab__item__wrapper"
            :style="`--order: ${index}`"
            v-for="(item, index) in pageData.categories"
            :key="item.title">
            <div
              :class="[
                'catalog__tab__item',
                'custom__cursor__pointer',
                {'catalog__tab__item--active': activeIndex == index}
              ]"
              @click="slideTo(index, item.key)">
              <components class="catalog__tab__item__icon" :is="item.icon"/>
              <span class="catalog__tab__item__name">{{ item.title }}</span>
              <span class="catalog__tab__item__count">{{ item.count }}</span>
            </div>
          </swiper-slide>
        </swiper-container>

        <div class="post__list__wrapper">
          <ul class="post__list">
            <li
              v-for="item in posts"
              :key="item.id"
              class="post__item"
              :id="`post-${item.id}`">
              <TestvPostItemMini
                class="comp__TestvPostItem"
                :post="item"
              />
            </li>
            <div v-show="loaded" class="loading__wrapper">
              <TestvLoading
                class="comp__TestvLoading"
                :loading="loading"
                :loadEnd="loadEnd"
                :noDataAvailable="!posts.length"
              />
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TestvPostItemMini from '@/components/TestvPostItemMini/index.vue'
import TestvLoading from '@/components/TestvLoading/index.vue'
import postListMixin from '@/mixins/post-list.js'
import ScrollMagic from 'scrollmagic'
import { mapState, mapActions } from 'vuex'
import { register } from 'swiper/swiper-element-bundle'
register()

export default {
  name: 'Catalog',

  mixins: [postListMixin],

  components: {
    TestvPostItemMini,
    TestvLoading
  },

  data () {
    return {
      activeIndex: '',
      params: {
        limit: 10,
        offset: 0,
        title_prefix: ''
      }
    }
  },

  computed: {
    ...mapState(['pageData'])
  },

  methods: {
    ...mapActions(['updateCategories']),
    slideTo (index, name) {
      this.activeIndex = index
      this.params.title_prefix = name
      this.$refs.swiperEl.swiper.slideTo(index)
      this.posts = []
      this.fetchData()
    },
    bindAnimationsForSwiper () {
      const el = document.querySelector('.catalog__tabs__wrapper')
      new ScrollMagic.Scene({
        triggerElement: el,
        offset: 0,
        triggerHook: 1,
        reverse: false
      })
      .setClassToggle(el, 'slide')
      .addTo(this.controller)
    }
  },

  mounted () {
    const swiperEl = this.$refs.swiperEl
    Object.assign(swiperEl, {
      updateOnWindowResize: true,
      breakpoints: {
        664: {
          centeredSlides: false,
          centeredSlidesBounds: false
        },
        768: {
          spaceBetween: 8,
          centeredSlides: false,
          centeredSlidesBounds: false
        },
        1024: {
          spaceBetween: 12,
          centeredSlides: false,
          centeredSlidesBounds: false
        }
      },
    });
    swiperEl.initialize()
    this.bindAnimationsForSwiper()
  },

  created () {
    this.updateCategories()
  },

  activated () {
    this.$refs.swiperEl.initialize();
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.catalog {
  padding-bottom: 40px;
}
.main__wrapepr {
  max-width: 996px;
  margin: auto;
  @media (min-width: $screen-md) {
    display: flex;
    justify-content: space-between;
    padding: 0 32px;
    column-gap: 72px;
  }
  .catalog__left {
    padding: 0 16px;
    margin: 32px 0;
    @media (min-width: $screen-md) {
      width: 104px;
      flex-shrink: 0;
      padding: 0;
    }
    @media (min-width: $screen-lg) {
      width: 225px;
    }
  }
  .catalog__right {
    flex: 1;
    overflow: hidden;
    @media (min-width: $screen-md) {
      margin-top: 32px;
    }
  }
  .catalog__title {
    font-size: 56px;
    font-weight: 600;
    line-height: 120%;
    white-space: pre-wrap;
    @media (min-width: $screen-md) {
      font-size: 48px;
    }
    @media (min-width: $screen-lg) {
      font-size: 80px;
    }
  }
  .catalog__desc {
    font-size: 15px;
    color: var(--dark-bwb-5);
  }
  .catalog__tab__item__wrapper {
    width: 92px;
    height: 102px;
    &:first-child {
      margin-left: 16px;
    }
    &:last-child {
      margin-right: 16px;
    }
    @media (min-width: $screen-md) {
      width: 81.5px;
      height: 120px;
      &:first-child {
        margin-left: 0px;
      }
      &:last-child {
        margin-right: 0px;
      }
    }
    @media (min-width: $screen-md) {
      width: 105px;
      height: 120px;
    }
  }
  .catalog__tab__item {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--dark-bwb-8);
    background: var(--dark-bwb-3);
    padding: 16px;
    box-sizing: border-box;
    border-radius: 2px;
    transition: .2s;
    .catalog__tab__item__icon {
      width: 24px;
      height: 24px;
      margin-bottom: 8px;
      @media (min-width: $screen-md) {
        width: 32px;
        height: 32px;
      }
    }
    .catalog__tab__item__name {
      font-size: 15px;
      line-height: 21px;
      font-weight: 500;
      white-space: nowrap;
    }
    .catalog__tab__item__count {
      font-size: 13px;
      line-height: 17px;
      font-family: "IBM Plex Mono", "DottedSongtiSquare";
    }
  }
  .catalog__tab__item__wrapper--active {
    .catalog__tab__item {
      background: var(--yellow-testv);
      color: var(--dark-bwb-0);
    }
  }
  .catalog__tab__item--active {
    background: var(--yellow-testv);
    color: var(--dark-bwb-0);
  }
}

.post__list__wrapper {
  margin-top: 8px;
  padding: 0 16px;
  .post__item:nth-last-child(2) {
    .comp__TestvPostItem {
      >>> .testv__post__item::after {
        display: none;
      }
    }
  }
  @media (min-width: $screen-md) {
    margin-top: 0;
    padding: 0;
  }
}

.loading__wrapper:first-child  {
  margin-top: 24px;
  @media (min-width: $screen-md) {
    margin-top: 32px;
  }
}

.post__item {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.8s ease;
  &.slide {
    opacity: 1;
    transform: translateY(0px);
  }
}

.catalog__tabs__wrapper {
  .catalog__tab__item__wrapper {
    .catalog__tab__item {
      opacity: 0;
      transform: translateX(20px);
      transition: opacity 0.8s ease, transform 0.8s ease;
      transition-delay: calc(var(--order) * 0.1s);
    }
  }
  &.slide {
    .catalog__tab__item__wrapper {
      .catalog__tab__item {
        opacity: 1;
        transform: translateX(0px);
      }
    }
  }
}
</style>
